import { QueryClient } from 'react-query';

export const queryClient = new QueryClient();

export * from './hooks';
